module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAQAAAAHDYbIAAAAFklEQVQIW2NgAIEGMAllwiASB0kOCACQtAYBP19cfwAAAABJRU5ErkJggg=="